import { Link } from "react-router-dom";
import error from "../../assets/images/error-img.png"
function Error404() {
  return (
    <div className="my-5 pt-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="text-center my-5">
              <h1 className="fw-bold text-error text-dark">4 <span className="error-text">0<img src={error} alt="" className="error-img"/></span> 4</h1>
              <h3 className="text-uppercase">Sorry, page not found</h3>
              <div className="mt-5 text-center">
                <Link to="/" className="btn btn-primary rounded linear-gradient-btn fs-16 cursor-pointer">Go Back</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Error404;